import type React from 'react'
import { twMerge } from 'tailwind-merge'

const variantStyles = {
  success: 'bg-green-50 text-green-800 dark:bg-green-900 dark:text-white',
  warning: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-900 dark:text-white',
  error: 'bg-red-50 text-red-800 dark:bg-red-900 dark:text-white',
}

type AlertProps = {
  variant: keyof typeof variantStyles
  message: string | React.ReactNode
  title?: string
} & React.ComponentPropsWithoutRef<'div'>

export default function Alert({ variant = 'success', className, title, message }: AlertProps) {
  className = twMerge('rounded px-4 py-3', variantStyles[variant], className)

  return (
    <div className={className}>
      {title && <h3 className='mb-2 font-semibold'>{title}</h3>}
      <div className='text-sm/6'>{message}</div>
    </div>
  )
}
